import Change from '../components/Change'

export default function formatChange({ change }) {
  return <Change change={change} />
}
